<script>
// NOTE:  This file is in the common folder but is no longer used by the client platform.
//        It is still used by the advisor platform and will remain in the common folder until that
//        is no longer the case.
export default {
  name: 'LegacyRwImage',
  props: {
    path: {
      type: String,
      required: false,
      default: null,
    },
    imgClass: {
      type: String,
      required: false,
      default: '',
    },
    // eslint-disable-next-line vue/no-unused-properties
    imgStyle: {
      type: [String, Object],
      required: false,
      default: '',
    },
    // eslint-disable-next-line vue/no-unused-properties
    imgTitle: {
      type: String,
      required: false,
      default: '',
    },
    maxWidth: {
      type: String,
      default: '100%',
    },
    position: {
      type: String,
      default: 'center center',
    },
  },
  data() {
    return {
      imageRoot: process.env.VUE_APP_BUCKET_URL,
    };
  },
};
</script>

<template>
  <div>
    <v-img
      v-if="path"
      :class="imgClass"
      :max-width="maxWidth"
      :position="position"
      :src="`${imageRoot}${path}`"
      class="mx-auto"
    />
  </div>
</template>
